/**
 * Verifica un token de Turnstile contra nuestra ruta server (/api/turnstile/verify).
 * Devuelve true si pasó (o si la verificación está deshabilitada/degradada por failsafe).
 */
export async function verifyTurnstile(token: string | null): Promise<boolean> {
  if (!token) return false;
  try {
    const res = await fetch("/api/turnstile/verify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    if (!res.ok) return false;
    const data = await res.json();
    return !!data.success;
  } catch {
    return false;
  }
}
